import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ButtonBS from '../../../../components/common/ButtonBS';
import PageLayout from '../../../../components/common/PageLayout';
import InputPinBS from '../../../../components/common/input-fields/InputPinBS';
import * as authActions from '../../../../actions/authActions';
import { setStage } from '../../../../actions/transactionActions';
import * as lightActions from '../../../../actions/lightActions';
import '../../../../styles/Pin/Pin.css';
import { EnterPin as i18n, Errors as i18nErrors } from '../../../../middlewares/i18n';

import { track } from '../../../../helpers/analytics';

class EnterPin extends PureComponent{

  constructor(props){
    super(props);
    this.state={
      pin:['','','',''],
      submiting: false,
      key: ''
    }
    this.submit = this.submit.bind(this);
    this.getPin = this.getPin.bind(this);
    this.forgotPin = this.forgotPin.bind(this);
  }

  submit(){
    track('Enter Pin Submit Clicked', {
      phone: this.props.auth.completePhone
    });

    if (this.state.pin.includes('')){
      this.props.actions.auth.invalidInput(i18nErrors[this.props.i18n.language.current].shortPin);
    } else {
      let pin='';
      for (var i=0; i < this.state.pin.length; i++){
        pin=pin+this.state.pin[i];
      }
      this.props.actions.auth.verifyPinV3(pin, authActions.PinType.Login);
    }
    this.setState({ 
      submiting: true
    }, ()=> this.setState({ submiting: false }))
  }

  forgotPin(){
    this.props.actions.auth.startChallenge()
  }

  getPin(value){
    this.setState({
      pin: value
    })
  }

  componentDidMount(){
    if(!this.props.mach.tiny)
      this.props.actions.light.setLight(1,"PPS")
  }

  componentDidUpdate(prevProps){
    if(this.props.mach.name === 'morty'){
      if (this.props.pinpad.enter && this.props.pinpad.enter !== prevProps.pinpad.enter)
        this.submit()
      else if (!Number.isNaN(parseInt(this.props.pinpad.key, 10)))
        this.setState({key: this.props.pinpad.key}, ()=>this.setState({key:''}))
      else if (this.props.pinpad.clear && this.props.pinpad.clear !== prevProps.pinpad.clear)      //Both cancel and clear
        this.setState({key: 'CLEAR'}, ()=>this.setState({key:''}))
    }
  }

  render(){
    return(
      <PageLayout title={i18n[this.props.i18n.language.current].title} errorMessage={this.props.auth.errorMessage}>
        <div className='pin-container'>
          <div className="reset-pin-container">
              <h6 className='bs-subtitle no-margin'>{i18n[this.props.i18n.language.current].forgotPin} 
              <span className='bs-link' onClick={ this.forgotPin }> {i18n[this.props.i18n.language.current].resetPin}</span></h6>
          </div> 
          <InputPinBS sendPin={this.getPin} submited={this.state.submiting}  submit={this.submit} keyPress={this.state.key}/>
          <h6 className='bs-subtitle no-margin welcome-pin'>{i18n[this.props.i18n.language.current].message}</h6>
        </div>
        { !this.props.mach.tiny ?
          <ButtonBS content={i18n[this.props.i18n.language.current].submit} onClick={this.submit}/> :
        null }
      </PageLayout>
    )
  }
}

function mapDispatchToProps(dispatch){
  return{
    actions: {
      auth: bindActionCreators(authActions, dispatch),
      setStage: bindActionCreators(setStage, dispatch),
      light: bindActionCreators(lightActions, dispatch)
    }
  }
}

function mapStateToProps(state){
  return{
    auth: state.auth,
    mach: state.machine,
    pinpad: state.pinpad,
    i18n: state.i18n,
    client: state.client
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EnterPin)